import { CheckboxProps } from '@mui/material/Checkbox';
import { makeStyles } from '@mui/styles';

export const CheckboxStyles = makeStyles<{}, CheckboxProps>({});
